/**
 * @(#)2020/3/6.
 * 默认校验项
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import { get } from "../../utils";
import { l } from "../../config/language";

export default (tmpProps, item) => {
  //date,Number类型不允许whitespace，会造成无法校验空状态
  // let whitespace = {};
  // if(!["Date","Number"].includes(tmpProps.inputType)){
  //   whitespace = {whitespace:true}
  // }
  const label = get(tmpProps, "formItemParam.label", l("defaultRulesLabel"));
  const len = get(item, "len", "");
  const max = get(item, "max", "");
  const min = get(item, "min", "");
  return {
    required: {
      required: true,
      message: l("defaultRules.rt", this, { label }),
    },
    max: {
      max: max,
      message: l("defaultRules.maxt", this, { label, len: max }),
    },
    len: {
      len: len,
      message: l("defaultRules.lent", this, { label, len: len }),
    },
    min: {
      min: min,
      message: l("defaultRules.mint", this, { label, len: min }),
    },
    wordNumLinAndChinese: {
      pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
      message: l("defaultRules.wnlcm", this),
    },
    noChinese: {
      pattern: /^[\x01-\x7f]*$/,
      message: l("defaultRules.nc", this),
    },
    wordNumAndLint: {
      pattern: /^[0-9a-zA-Z._]+$/,
      message: l("defaultRules.wnlt", this),
    },
    wordNumLintAndColLint: {
      pattern: /^[0-9a-zA-Z._-]+$/,
      message: l("defaultRules.wnlclt", this),
    },
    headwordNumAndLint: {
      pattern: /^[a-zA-Z][0-9a-zA-Z._]*$/,
      message: l("defaultRules.hnlt", this),
    },
  };
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/defaultRules.js